import React from 'react'
import { useNavigate } from 'react-router-dom'

import { CaretRight } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Skeleton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const MetricsBreadcrumbs = ({ breadcrumbs }) => {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleClick = (breadcrumb, isClickable) => {
    if (isClickable && breadcrumb?.url) {
      navigate(breadcrumb.url)
    }
  }

  if (!breadcrumbs?.length) return null

  return (
    <Styles.Container>
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        const isClickable = !isLast && !breadcrumb.loading

        return (
          <React.Fragment key={index}>
            <Styles.BreadCrumbContainer
              isLast={isLast}
              isClickable={isClickable}
              aria-busy={!!breadcrumb.loading}
              onClick={() => handleClick(breadcrumb, isClickable)}
            >
              {breadcrumb.loading ? (
                <Skeleton variant="rounded" width={120} height={16} color={theme.colors.disabled.surface} />
              ) : (
                <>
                  <Text type="titleS">{breadcrumb?.title}</Text>
                  <Text type="bodyMRegular">{breadcrumb.subtitle}</Text>
                </>
              )}
            </Styles.BreadCrumbContainer>
            {!isLast && <CaretRight size={24} color={theme.colors.text.subtle} />}
          </React.Fragment>
        )
      })}
    </Styles.Container>
  )
}

export default MetricsBreadcrumbs
